function isFinite(value) {
    return Number.isFinite(value);
}

export { isFinite };
